import { ID } from '../../utils/codecUtils';
import { relatedObjectsCountsSchema } from '../models/relatedObjectsCounts.schema';

export const getRelatedObjectsCounts = (queueId: ID) => {
  return {
    endpoint: `/queues/${queueId}/related_objects_counts`,
    method: 'GET',
    responseSchema: relatedObjectsCountsSchema,
  } as const;
};
